<template>
  <div>
    <h1 class="text-h6 text-sm-h5 font-weight-bold">{{ headline }}</h1>
    <v-breadcrumbs v-if="!$vuetify.breakpoint.xs" :items="links" class="pa-0 ma-0">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template></v-breadcrumbs
    >
    <h1 class="text-subtitle-1">{{ caption }}</h1>
  </div>
</template>

<script>
export default {
  props: {
    headline: String,
    caption: String,
    link: { type: Array, default: () => [] }
  },
  data: () => ({
    items: [
      {
        text: 'Trang chủ',
        disabled: false,
        to: '/dashboard'
      }
    ]
  }),
  computed: {
    links() {
      return [...this.items, ...this.link]
    }
  }
}
</script>
<style scoped>
.v-breadcrumbs {
  padding: 0;
  margin: 0;
}
.v-breadcrumbs li {
  padding: 0px;
  margin: 0px;
}
</style>
